import { useOrganizationGenerationDetail } from "@dutyon/apis";
import { OrganizationGenerationJobDetails } from "@dutyon/ui-kit";
import { useParams } from "react-router-dom";
export function GenerationJobPage() {
  const detail = useOrganizationGenerationDetail("backoffice", useParams().jobId ?? "");
  return (
    <OrganizationGenerationJobDetails
      app="backoffice"
      state={detail.state}
      job={detail.job}
      refreshing={detail.refreshing}
      onRefresh={detail.refresh}
    />
  );
}
